// Blocos da Home nova, na ordem da página. No staging cada bloco ficava atrás de um toggle home_nova_* da API; aqui a Home
// nova é a home, sem toggle (docs/home-variantes.md, Andamento) — sobram o nome dos blocos e o namespace i18n de cada um.
// O arquivo fica neste caminho porque as seções importam `homeNovaNamespace` daqui, como no staging.

/**
 * Nome do bloco (igual à pasta em src/components/home-nova/ e ao namespace components/home-nova/<bloco>). `header-footer` não
 * tem mais componente (header e footer são os do site, decisão do dono): o namespace só traz o rótulo `skipLink` do link
 * "Pular para o conteúdo" do shell, e continua no formato do bundle aprovado dos pares.
 */
export const HOME_NOVA_BLOCKS = ['hero', 'videos', 'tecnologia', 'pro-players', 'jogos', 'cobertura', 'fps-booster', 'jogos-por-game', 'faq', 'header-footer'] as const;
export type HomeNovaBlock = (typeof HOME_NOVA_BLOCKS)[number];

/** Namespace i18n do bloco. */
export const homeNovaNamespace = (block: HomeNovaBlock) => `components/home-nova/${block}`;
